const request = require('./request')

export function list(args) {
	return request.get(`/questions/list`, args)
}

export function update(args) {
	return request.post(`/questions/update`, args)
}

export function insert(args) {
	return request.post(`/questions/insert`, args)
}

export function remove(args) {
	return request.post(`/questions/remove`, args)
}

export function find(args) {
	return request.get(`/questions/find`, args)
}

export function listFeedback(args) {
	return request.get(`/questions/listFeedback`, args)
}

export function updateFeedback(args) {
	return request.post(`/questions/updateFeedback`, args)
}